import FilesList from "../FilesList";

const filesList = [
    {
        id: 0,
        name: 'filename.png',
        link: '/file.png',
    },
    {
        id: 1,
        name: 'file.jpg',
        link: '/file.jpg',
    },
    {
        id: 2,
        name: 'excel.xls',
        link: '/file.xls',
    },
    {
        id: 3,
        name: 'filename.png',
        link: '/file.png',
    },
    {
        id: 4,
        name: 'file.jpg',
        link: '/file.jpg',
    },
    {
        id: 5,
        name: 'excel.xls',
        link: '/file.xls',
    },
]

export const UPGrouptableFields = [
    {
        id: 0,
        name: 'checkbox',
        label: '',
        props: {
            width: '40px',
        },
    },
    {
        id: 1,
        name: 'number',
        label: 'Номер УП',
        props: {
            width: '70px',
        },
    },
    {
        id: 2,
        name: 'name',
        label: 'Наименование УП',
    },
    {
        id: 3,
        name: 'current_documentation',
        label: 'Действующая документация',
    },
    {
        id: 4,
        name: 'closing_date_planned',
        label: 'Плановая дата закрытия УП',
        props: {
            width: '100px',
        },
    },
    {
        id: 5,
        name: 'closing_date_real',
        label: 'Дата закрытия УП',
        props: {
            width: '100px',
        },
    },
    {
        id: 6,
        name: 'files',
        label: 'Необходимые файлы',
        props: {
            width: '300px',
        },
    },
]